const module = { name: 'shared/global/detectTouch', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';

function init() {
    const touch = !!('ontouchstart' in window);
    $(document.body)
        .toggleClass('no-touch', !touch)
        .toggleClass('touch', touch);
}
module.exports = {
    init,
};
export default module.exports;